import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { HpbPageList_HpbPageListPage_Query } from "./query";

type Props = {
	hotelID: string;
};

export const useHPBListQuery = ({ hotelID }: Props) => {
	const { data } = useCustomSuspenseQuery(HpbPageList_HpbPageListPage_Query, {
		variables: {
			hotelID,
		},
	});

	return {
		data,
	};
};
